
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import "firebase/storage";



const firebaseConfig = {
 apiKey: "AIzaSyBq64qKTzzxpbvZAXATOBfxEWiEMULBBZY",
  authDomain: "atindia-packers.firebaseapp.com",
  projectId: "atindia-packers",
  storageBucket: "atindia-packers.firebasestorage.app",
  messagingSenderId: "18631913168",
  appId: "1:18631913168:web:e5c4a1f17f90b57dfcb8d5",
  measurementId: "G-WN4641Z9FT"
 
};


const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;